// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"common-DownloadButton__downloadButton--asYPg","text":"common-DownloadButton__text--3g7XF","iconDefault":"common-DownloadButton__iconDefault--1TK8l"};